import { render } from "./Notification.vue?vue&type=template&id=4ccd5aa5"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=4ccd5aa5&lang=css"

import exportComponent from "/codebuild/output/src886087124/src/dt-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__